export default __webpack_public_path__ + "static/media/arrow.9d82b6d2.svg";